import "swiper/css/pagination";
import { priceTableData } from "constants/prices";

import { useContext, useEffect, useState, useRef } from "react";

import { Row } from "antd";
import { AppContext } from "App";
import { PriceCard } from "components/pages/Prices/components/PriceCard";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
interface PriceTablesProps {
    pricingCategory?: string;
    discountedAmount?: number;
    onPayNow?: (_selectedPrice: number) => void;
    isOnPaywall?: boolean;
    setAccountantReviewRequested?: (_value: boolean) => void;
    setAmount?: (_amount: number) => void;
}
/* eslint-disable no-unused-vars */
export enum PricingCategory {
    SinglePayeIncome = "singlePayeIncome",
    SingleSelfEmploymentIncome = "singleSelfEmploymentIncome",
    MultipleIncomes = "multipleIncomes",
    MultipleIncomesWithAccountant = "multipleIncomesWithAccountant",
}
/* eslint-disable no-unused-vars */
export enum TableCategory {
    SimpleReturn = "Simple Return",
    SelfEmployedReturn = "Self-Employed Return",
    StandardReturn = "Standard Return",
    AccountantReviewedReturn = "Reviewed Return",
    }

export const categoryMap: Record<PricingCategory, TableCategory[]> = {
    [PricingCategory.SinglePayeIncome]: [TableCategory.SimpleReturn],
    [PricingCategory.SingleSelfEmploymentIncome]: [TableCategory.SelfEmployedReturn],
    [PricingCategory.MultipleIncomes]: [TableCategory.StandardReturn],
    [PricingCategory.MultipleIncomesWithAccountant]: [TableCategory.SelfEmployedReturn],
};
const PriceTables = ({ pricingCategory, discountedAmount, onPayNow, isOnPaywall = false, setAccountantReviewRequested, setAmount }: PriceTablesProps) => {
    const { isMobile, maxWidth } = useContext(AppContext);
    const [selectedKey, setSelectedKey] = useState<string | null>(null);

    const tablesToShow = (isOnPaywall
        ? priceTableData.filter(table => {
            const allowedCategories = categoryMap[pricingCategory as PricingCategory] ?? [];
            const categoryMatch =
            allowedCategories.includes(table.category as TableCategory) ||
            table.category === TableCategory.AccountantReviewedReturn;

            return categoryMatch;
        })
        : priceTableData
    );

    const [activeIndex, setActiveIndex] = useState(0);
    const swiperRef = useRef(null);

    const handleSlideChange = (swiper: any) => {
        setActiveIndex(swiper.activeIndex);
    };

    useEffect(() => {
        if (!selectedKey) {
            const defaultTable = tablesToShow.find(table => table.category !== TableCategory.AccountantReviewedReturn);
            if (defaultTable) {
                setSelectedKey(defaultTable.category);
            }
        }
    }, [selectedKey, tablesToShow]);
    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            gap: "32px",
            paddingTop: isMobile ? "0" : "40px",
            flexDirection: isMobile ? "column" : "row",
            maxWidth: maxWidth,
            marginBottom: isMobile ? "20px" : "",
        }}>
            {isMobile ? (
                <div style={{ maxWidth: maxWidth, padding: isMobile ? "0px" : "24px" }}>
                    <Row style={{ maxWidth: "335px", margin: "20px auto" }}>
                        <div style={{ width: "100%" }}>
                            <Swiper
                                className="price-tables__swiper"
                                {...({ slidesPerView: 1.1 } as any)}
                                {...({ spaceBetween: 16 } as any)}
                                onSlideChange={handleSlideChange}
                                pagination={{ clickable: true }}
                                onSwiper={(swiper: any) => { swiperRef.current = swiper; }}
                                modules={[Pagination]}
                            >
                                {tablesToShow.map((table, index) => (
                                    <SwiperSlide key={index}>
                                        <PriceCard key={index} {...table} isPaymentMode={isOnPaywall}
                                            onSelect={() => {
                                                setSelectedKey(table.category);
                                                onPayNow && onPayNow(parseFloat(table.originalPrice));
                                                setAccountantReviewRequested?.(
                                                    table.category === TableCategory.AccountantReviewedReturn
                                                );
                                            }}
                                            amount={discountedAmount}
                                            isSelected={selectedKey === table.category}
                                            setAmount={setAmount}
                                            className={activeIndex === index
                                                ? "price-tables__card-purple"
                                                : "price-tables__card"}
                                            isActive={activeIndex === index}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </Row>
                </div>
            ) : (
                tablesToShow.map((table, index) => (
                    <PriceCard
                        key={index}
                        {...table}
                        isPaymentMode={isOnPaywall}
                        onSelect={() => {
                            setSelectedKey(table.category);
                            onPayNow && onPayNow(parseFloat(table.originalPrice));
                            setAccountantReviewRequested?.(
                                table.category === TableCategory.AccountantReviewedReturn
                            );
                        }}
                        amount={discountedAmount}
                        isSelected={selectedKey === table.category}
                        setAmount={setAmount}
                        isActive={activeIndex === index}
                        className={activeIndex === index
                            ? "price-tables__card-purple"
                            : "price-tables__card"}
                    />
                ))
            )}

        </div>
    );
};

export default PriceTables;
